// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".state-card[data-v-31fd0c43]{background-color:initial;transition:background-color .2s ease,box-shadow .2s ease}.state-card[data-v-31fd0c43]:hover{background-color:#fff;box-shadow:0 4px 16px #0000001a,0 1px 4px #0000000f}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
